import React, { useEffect, useState } from "react";
import AddBusinessUnitModal from "./AddBusinessUnit";
import { BusinessUnit, BusinessUnitFormData } from "../../interfaces/businessUnits";
import {
  deleteBusinessUnit,
  getBusinessUnitById,
  getBusinessUnits,
} from "../../apis/businessUnits";

const BusinessUnitsList: React.FC = () => {
  const [businessUnits, setBusinessUnits] = useState<BusinessUnit[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [editableId, setEditableId] = useState<number | null>(null);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState<BusinessUnitFormData | null>(null);

  useEffect(() => {
    fetchBusinessUnits();
  }, []);

  const fetchBusinessUnits = async () => {
    try {
      const res: any = await getBusinessUnits();
      setBusinessUnits(res.data || res);
    } catch (error) {
      console.log("Error fetching business units:", error);
    }
  };

  const handleAddBusinessUnit = () => {
    fetchBusinessUnits();
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Business Units
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            List of all business units.
          </p>
        </div>

        <button
          type="button"
          onClick={() => setOpenModal(true)}
          className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
        >
          Add Business Unit
        </button>
      </div>

      <AddBusinessUnitModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setEditableId(null);
          setSelectedBusinessUnit(null);
        }}
        onSuccess={handleAddBusinessUnit}
        editableId={editableId}
        businessUnitData={selectedBusinessUnit}
      />

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Name
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Legal Name
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      GST Number
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      State Code
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Default
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {businessUnits.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="py-4 text-center text-sm text-gray-500">
                        No business units found
                      </td>
                    </tr>
                  ) : (
                    businessUnits.map((bu: any) => (
                      <tr key={bu.id}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {bu.name}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-700">
                          {bu.legalName || bu.legal_name}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-700">
                          {bu.gstNumber || bu.gst_number}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-700">
                          {bu.stateCode || bu.state_code}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-700">
                          {(bu.isDefault ?? bu.is_default) ? "Yes" : "No"}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-700">
                          <div className="flex items-center gap-2">
                            <button
                              onClick={async () => {
                                try {
                                  const res: any = await getBusinessUnitById(bu.id);
                                  const data = res.data || res;
                                  setEditableId(bu.id);
                                  setSelectedBusinessUnit({
                                    name: data.name,
                                    gstNumber: data.gstNumber || data.gst_number,
                                    legalName: data.legalName || data.legal_name,
                                    address: data.address,
                                    stateCode: data.stateCode || data.state_code,
                                    tallyCompanyName:
                                      data.tallyCompanyName || data.tally_company_name || "",
                                    isDefault: !!(data.isDefault ?? data.is_default),
                                  });
                                  setOpenModal(true);
                                } catch (error) {
                                  console.log("Error fetching business unit:", error);
                                }
                              }}
                              className="px-3 py-2 text-sm text-white bg-primary rounded"
                            >
                              Edit
                            </button>
                            <button
                              onClick={async () => {
                                const yes = window.confirm("Delete this business unit?");
                                if (!yes) return;
                                await deleteBusinessUnit(bu.id);
                                fetchBusinessUnits();
                              }}
                              className="px-3 py-2 text-sm text-white bg-red-600 rounded"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessUnitsList;

